<template>
    <el-tabs v-model="tabsKey"  @tab-click="handleClick">
        <el-tab-pane label="查詢" name="search"> 
        <search  @editTabs="editTabs" @detailTabs="detailTabs"  />
        </el-tab-pane>
        <el-tab-pane label="增加" name="add" v-if="isShowAdd">
            <Add @back="back" />
        </el-tab-pane>
        <el-tab-pane label="詳細" name="detail"  v-if="isShowDetail">
            <memberDetail @back="back"  :memberKey="memberKey" @editTabs="editTabs" />
        </el-tab-pane>
        <el-tab-pane label="編輯" name="edit" v-if="isShowEdit">
            <Edit  :memberKey="memberKey" @back="back"  />
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import search from './Member/search'
import Add from './Member/Add'
import memberDetail from './Member/memberDetail'
import Edit from './Member/Edit'
    export default {
        name: 'Member',
       
        data() {
            return {
                tabsKey: 'search',
                 isShowDetail: false,
                isShowEdit: false,
                isShowAdd: true,
                memberkey: ''
            }
        },
        components: {
            search,
            Add,
            memberDetail,
            Edit
        },
        methods: {
              back(){
                this.tabsKey = 'search',
                this.isShowDetail = false
                this.isShowEdit = false
                this.isShowAdd = true
            },
          
            detailTabs: function(memberKey){
                this.memberKey = memberKey
                 this.isShowAdd = false
                this.tabsKey = 'detail',
                this.isShowDetail = true
            },
            removeDetailTabs: function(){
                this.isShowDetail = false
                this.isShowAdd = true
                this.tabsKey = 'search'
            },
            editTabs: function (memkey) {
                this.memberkey = memkey
                this.isShowAdd = false
                this.isShowDetail = false
                this.isShowEdit = true
                this.tabsKey = 'edit'
            },
            removeEditTabs: function(){
                this.isShowEdit = false
                this.isShowAdd = true
                this.tabsKey =search
            },
            handleClick: function (tab) {
                if (tab.name == 'search') {
                    this.removeEditTabs()
                     this.removeDetailTabs()
                     this.isShowAdd = true
                }
            }

        },
      
    }
</script>

<style scoped>
    
</style>